import { forwardRef } from 'react';
import SvgIcon, { type SvgIconProps } from '@material-ui/core/SvgIcon';

export const IconOverlayText = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <SvgIcon
    {...props}
    ref={ref}
    viewBox="0 0 20 20"
    data-fill-none
  >
    <path
      d="M6.67446 4.52051H4.45907C4.256 4.52051 4.08984 4.68666 4.08984 4.88974V7.10512C4.08984 7.3082 4.256 7.47435 4.45907 7.47435C4.66215 7.47435 4.82831 7.3082 4.82831 7.10512V5.25897H6.67446C6.87754 5.25897 7.04369 5.09282 7.04369 4.88974C7.04369 4.68666 6.87754 4.52051 6.67446 4.52051Z"
      fill="currentColor"
    />
    <path
      d="M15.5358 4.52051H13.3204C13.1173 4.52051 12.9512 4.68666 12.9512 4.88974C12.9512 5.09282 13.1173 5.25897 13.3204 5.25897H15.1666V7.10512C15.1666 7.3082 15.3327 7.47435 15.5358 7.47435C15.7389 7.47435 15.905 7.3082 15.905 7.10512V4.88974C15.905 4.68666 15.7389 4.52051 15.5358 4.52051Z"
      fill="currentColor"
    />
    <path
      d="M6.67446 15.5975H4.82831V13.7513C4.82831 13.5482 4.66215 13.3821 4.45907 13.3821C4.256 13.3821 4.08984 13.5482 4.08984 13.7513V15.9667C4.08984 16.1698 4.256 16.3359 4.45907 16.3359H6.67446C6.87754 16.3359 7.04369 16.1698 7.04369 15.9667C7.04369 15.7636 6.87754 15.5975 6.67446 15.5975Z"
      fill="currentColor"
    />
    <path
      d="M15.5358 13.3821C15.3327 13.3821 15.1666 13.5482 15.1666 13.7513V15.5975H13.3204C13.1173 15.5975 12.9512 15.7636 12.9512 15.9667C12.9512 16.1698 13.1173 16.3359 13.3204 16.3359H15.5358C15.7389 16.3359 15.905 16.1698 15.905 15.9667V13.7513C15.905 13.5482 15.7389 13.3821 15.5358 13.3821Z"
      fill="currentColor"
    />
    <path
      d="M7.28906 8.26107V7.44857C7.28906 7.37674 7.3176 7.30785 7.36839 7.25706C7.41918 7.20627 7.48807 7.17773 7.5599 7.17773H12.4349C12.5067 7.17773 12.5756 7.20627 12.6264 7.25706C12.6772 7.30785 12.7057 7.37674 12.7057 7.44857V8.26107"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.99805 7.17773V13.6777"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.18555 13.6777H10.8105"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
));
IconOverlayText.displayName = 'IconOverlayText';
